/**
 * Step 3 Countries: Table for selecting countries
 *
 * Migrated from: lego/page/etmf/overview/update-study/Step3Countries.jsx
 */

import React, { useState } from 'react'
import { useServiceContext } from '../../../../root'
import { useDialogContext } from './context/useDialogContext'
import {
  TableMultiSelectionWrapper,
  SelectAllRows,
  SelectRow
} from '../../../../components/rcm-table/TableMultiSelection'
import { RcmTable } from '../../../../components/rcm-table/RcmTable'
import { RcmTableDataWrapper } from '../../../../components/rcm-table/RcmTableDataWrapper'
import { ErrorMessage } from 'formik'
import type { FormValues } from './context/DialogContext'
import TableHeadRow from '../../../../components/table/TableHeadRow'
import { TableHeadCell } from '../../../../components/table/TableComponents'

interface Step3CountriesProps {
  values: FormValues
  setFieldValue: (field: string, value: any) => void
  reloadController: (reloadFn: () => void) => void
}

export default function Step3Countries({ values, setFieldValue, reloadController }: Step3CountriesProps) {
  const dialogData = useDialogContext()
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [preselectedIds, setPreselectedIds] = useState<string[]>([])

  // Helper function to truncate text
  const excerpt = (text: string, maxLength: number) => {
    if (!text || text.length <= maxLength) return text
    return text.substring(0, maxLength) + '...'
  }

  return (
    <div className="theme-sandman">
      {values.environment && (
        <RcmTableDataWrapper
          reloadController={reloadController}
          doPreload={true}
          loadData={(tableParams) => {
            const req = dialogData.loadCountryOptions(tableParams)
            req.then((data: any) => {
              // preselect checkboxes
              if (!data.isCached) {
                setFieldValue('countries', [])
              } else {
                setFieldValue('countries', values.countries)
                setPreselectedIds(values.countries)
              }
            })
            return req
          }}
          defaultSortBy={'NAME'}
          defaultSortDesc={false}
          persistenceKey={'ETMF_UPDATE_STUDY_STRUCTURE_SELECT_COUNTRIES'}
        >
          <TableMultiSelectionWrapper
            isSelectTotalEnabled={false}
            preselectedIds={preselectedIds}
            onChange={(ids) => {
              setFieldValue('countries', ids)
            }}
          >
            <RcmTable
              className="chita-table fsiTable"
              noResultsText="There are no entries that match your filter selections. Please adjust one or more filters and try again."
              rowKey="id"
              hidePaginate={true}
              HeadRow={
                <TableHeadRow>
                  <th className="clipped-cell with-checkbox">
                    <SelectAllRows />
                  </th>
                  <TableHeadCell id="e4c87626-e90f-40f1-9658-c3cc4a71a727" sort={'NAME'}>
                    {translate('NAME')}
                  </TableHeadCell>
                </TableHeadRow>
              }
              Row={({ row, index }) => (
                <tr key={row.id}>
                  <td className="clipped-cell with-checkbox">
                    <SelectRow row={row} />
                  </td>
                  <td title={row.name}>{excerpt(row.name, 100)}</td>
                </tr>
              )}
            />
          </TableMultiSelectionWrapper>
          <ErrorMessage name="countries" component="div" className="error-message text-danger" />
        </RcmTableDataWrapper>
      )}
    </div>
  )
}
